export { default as Content } from "./Content";
export { default as Partners } from "./Partners";
export { default as PricingCards } from "./PricingCards";
export { default as Features } from "./Features";
export { default as FranchiseCTA } from "./FranchiseCTA";
